import script from "./ContactConversationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactConversationList.vue?vue&type=script&lang=ts&setup=true"

import "./ContactConversationList.vue?vue&type=style&index=0&id=6c8804bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c8804bb"]])

export default __exports__